// app/javascript/controllers/weployer_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "checkbox",
    "weployerButton",
    "requestButton",
    "permButton",
  ];
  declare weployerButtonTarget: HTMLButtonElement;
  declare requestButtonTarget: HTMLButtonElement;
  declare permButtonTarget: HTMLButtonElement;
  declare checkboxTargets: Array<HTMLInputElement>;

  connect(): void {
    this.weployerButtonTarget.disabled = true;
    this.requestButtonTarget.disabled = true;
    this.permButtonTarget.disabled = true;
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.addEventListener("change", () => this.toggleUpdateButton());
    });
    const weployerUrl = this.data.get("weployer");
    this.weployerButtonTarget.addEventListener("click", (event) =>
      this.submitPositionIds(event, weployerUrl)
    );
    const permanentUrl = this.data.get("permanent");
    this.permButtonTarget.addEventListener("click", (event) =>
      this.submitPositionIds(event, permanentUrl)
    );
    this.toggleUpdateButton();
  }

  toggleUpdateButton() {
    const anyChecked = this.checkboxTargets.some(
      (checkbox) => checkbox.checked
    );
    this.weployerButtonTarget.disabled = !anyChecked;
    this.requestButtonTarget.disabled = !anyChecked;
    this.permButtonTarget.disabled = !anyChecked;
  }

  submitPositionIds(event, baseUrl) {
    event.preventDefault();

    const selectedIds = this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)
      .join(",");

    if (selectedIds) {
      const url = `${baseUrl}?position_ids=${selectedIds}`;
      window.location.href = url;
    }
  }
}
